import { useState } from "react";
import { Btn, FieldLabel, Input, Modal } from "components/ui/index";
import { T } from "theme/index";
import { fmtIDR, uid } from "utils/format";

const EMOJIS = ["🚩","🛡️","🚀","🏝️","🏠","🎓","💍","👶","🚗","🏖️","🔥","💼","🌅","🧳","🩺"];

export default function MilestoneModal({ milestone, existingGroups, onSave, onClose }) {
  const [f, setF] = useState(milestone || { id:uid(), name:"", icon:"🚩", targetAmount:"", targetDate:"", groupNames:[] });
  const set = (k, v) => setF(p => ({ ...p, [k]:v }));

  const toggleGroup = (g) => {
    setF(p => {
      const has = p.groupNames.includes(g);
      return { ...p, groupNames: has ? p.groupNames.filter(x => x !== g) : [...p.groupNames, g] };
    });
  };

  const valid = f.name.trim() && Number(f.targetAmount) > 0;
  const allSelected = f.groupNames.length === 0;

  return (
    <Modal title={milestone ? "Edit Milestone" : "Milestone Baru"} onClose={onClose}>
      <Input label="Nama" value={f.name} onChange={e => set("name", e.target.value)} placeholder="Dana Darurat, Networth 1M, DP Rumah..." />

      <div style={{ marginBottom:14 }}>
        <FieldLabel>Ikon</FieldLabel>
        <div style={{ display:"flex", gap:5, flexWrap:"wrap" }}>
          {EMOJIS.map(e => (
            <button key={e} onClick={() => set("icon", e)} type="button" aria-label={`Pilih ikon ${e}`}
              style={{ width:36, height:36, borderRadius:6, fontSize:18, cursor:"pointer", background:f.icon===e?T.gold+"25":T.surface, border:`1px solid ${f.icon===e?T.gold:T.border}`, WebkitTapHighlightColor:"transparent" }}>{e}</button>
          ))}
        </div>
      </div>

      <Input label="Target (Rp)" type="number" inputMode="numeric" value={f.targetAmount}
        onChange={e => set("targetAmount", e.target.value)} placeholder="50000000" />

      <Input label="Target tanggal (opsional)" type="date" value={f.targetDate || ""}
        onChange={e => set("targetDate", e.target.value)} />

      <div style={{ marginBottom:16 }}>
        <FieldLabel>Grup investasi yang ditrack</FieldLabel>
        {existingGroups.length === 0 ? (
          <div style={{ color:T.muted, fontSize:12 }}>Belum ada grup investasi. Tambah investasi dulu di menu Investasi.</div>
        ) : (
          <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
            {existingGroups.map(g => {
              const checked = f.groupNames.includes(g);
              return (
                <label key={g} style={{ display:"flex", alignItems:"center", gap:8, background:T.surface, border:`1px solid ${checked?T.gold:T.border}`, borderRadius:8, padding:"9px 10px", color:checked?T.text:T.muted, fontSize:13, cursor:"pointer" }}>
                  <input type="checkbox" checked={checked} onChange={() => toggleGroup(g)} style={{ accentColor:T.gold, width:16, height:16, flexShrink:0 }} />
                  {g}
                </label>
              );
            })}
          </div>
        )}
        <div style={{ color:T.muted, fontSize:11, marginTop:8 }}>
          {allSelected ? "Gak ada yang dipilih → milestone ini nge-track SEMUA grup." : `Nge-track ${f.groupNames.length} grup terpilih.`}
        </div>
      </div>

      {Number(f.targetAmount) > 0 && (
        <div style={{ color:T.muted, fontSize:12, marginBottom:14 }}>
          Target: <span style={{ color:T.text, fontWeight:700 }}>{fmtIDR(Number(f.targetAmount))}</span>
        </div>
      )}

      <div style={{ display:"flex", justifyContent:"flex-end", gap:8 }}>
        <Btn variant="ghost" onClick={onClose}>Batal</Btn>
        <Btn onClick={() => { if(valid){ onSave({ ...f, targetAmount:Number(f.targetAmount) }); onClose(); } }} disabled={!valid}>💾 Simpan</Btn>
      </div>
    </Modal>
  );
}
